import { useContext, useEffect } from "react";

import { getManagerUrl } from "@/config";

import SearchInput from "../../../manager/components/search-input/search-input";
import TextInput from "../../../shared/components/text-input/text-input";
import AuthContext from "../../../shared/context/auth-context";
import { IEnumerationOption } from "../../../shared/definitions/datatypes";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData } from "../../../shared/utils/api";
import {IDatamodelReportData} from "./datamodel-report-new";

interface IDatamodelReportSetupConfig {
    onDataChange: (newData: IDatamodelReportData) => void;
    datamodelReportData: IDatamodelReportData;
}

const DatamodelReportSetup = ({onDataChange, datamodelReportData}: IDatamodelReportSetupConfig) => {
  const authCtx = useContext(AuthContext);
  const { sendRequest: getDatamodels, data: getDatamodelData } = useHttp(getAllData, false, authCtx.token, undefined, "platform");
  const hasManager = getManagerUrl() !== "";
  
  const tableChoices = [
    {id: "alertcase", name: "AlertCase"},
    {id: "event", name: "Event"},
    {id: "entity", name: "Entity"},
  ];
  
  useEffect(() => {
    if (datamodelReportData?.datamodel_type === "entity") {
      getDatamodels("datamodel/entities?archived=false");
    } else if (datamodelReportData?.datamodel_type === "event") {
      getDatamodels("datamodel/events?archived=false");
    } else if (datamodelReportData?.datamodel_type === "alertcase" && !hasManager) {
      getDatamodels("datamodel/alerts?archived=false");
    }
  }, [datamodelReportData]);

  return <div>
    <div className="datamodelReportNew-tableDropdown">
      <TextInput
        type={"text"}
        id={"report_name"}
        required={true}
        inputKey={"report_name"}
        handleOnChange={(selectedText: string) => {
          const data = {...datamodelReportData};
          data.report_name = selectedText;
          onDataChange(data);
        }}
        placeholder={"Report name"}
        label="Report name"
        value={datamodelReportData?.report_name}
        autofocus={false}
        defaultValue={datamodelReportData?.report_name}
      />
      <SearchInput
        label={"Datamodel type"}
        handleOnChange={(selectedOption: IEnumerationOption | undefined) => {
          const data = {...datamodelReportData};
          data.datamodel_type = selectedOption?.id || "";
          onDataChange(data);
        }}
        data={tableChoices}
        selectedOption={datamodelReportData?.datamodel_type}
        inputKey={"datamodelType"}
        required={true}
      />

      {(datamodelReportData?.datamodel_type !== "alertcase" || !hasManager) &&
      <SearchInput
        label={"Datamodel"}
        handleOnChange={(selectedOption: IEnumerationOption | undefined) => {
          const data = {...datamodelReportData};
          data.datamodel_id = selectedOption?.id || "";
          onDataChange(data);
        }}
        data={getDatamodelData?.rows || []}
        selectedOption={datamodelReportData?.datamodel_id || ""}
        inputKey={"datamodel"}
        required={true}
      />}
    </div>
  </div>;
};

export default DatamodelReportSetup;